<!--
 * @Descripttion: 购物车
 * @FilePath: /mall-wap-vue/src/views/cart/index.vue
 * @Author: 张兴业
 * @Date: 2020-09-24 15:39:58
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-05-13 19:26:24
-->
<template>
  <div class="cart_new_con">
    <!-- titleBar -->
    <title-bar-back :title="'购物车'" :showBack="false">
      <div
        class="title_right font12 font_weight400 colo087"
        @click="clickDelete"
      >
        管理
      </div>
    </title-bar-back>
    <!-- 商品列表 -->
    <div
      v-for="(item, index) in getCartList.tCartArrayDTO.slice(
        0,
        getCartList.tCartArrayDTO.length - 1
      )"
      :key="index"
      class="list_list"
    >
      <!-- 列表头部 -->
      <van-sticky :offset-top="48">
        <list-header
          v-if="item.list && item.list.length"
          :title="item.typeValue"
          :isSelect="isSingleAll(item.type, item.list)"
          @isCheckedSingleAll="isCheckedSingleAll(item.type, item.list)"
        />
      </van-sticky>
      <!-- 列表 -->
      <product-list
        v-if="item.list && item.list.length"
        :productList="item.list"
        @batchSingleSelect="batchSingleSelect"
        @deleteProduct="deleteProduct"
        @changeNum="changeNum"
        @chooseSpec="chooseSpec"
        @goProductDetail="goProductDetail"
      />
    </div>
    <!-- 失效宝贝 -->
    <cant-buy
      v-if="
        getCartList.tCartArrayDTO.slice(getCartList.tCartArrayDTO.length - 1)[0]
          .type === 3 &&
          getCartList.tCartArrayDTO.slice(
            getCartList.tCartArrayDTO.length - 1
          )[0].list.length > 0
      "
      @clearAllCant="clearAllCant"
      @goProductDetail="goProductDetail"
    />
    <!-- 切换推荐 -->
    <!-- <recom-switch @switchCase="switchCase" /> -->
    <!-- 底部按钮 -->
    <bottom-btn
      :showDeleteAll="showDeleteAll"
      :allSelect="isAll()"
      @isCheckedleAll="isCheckedleAll"
      @deleteCart="deleteCart"
      @goPurCheckOut="goPurCheckOut"
    />
    <!-- 选择弹窗 -->
    <sku-action-sheet
      v-if="showSkuSheet"
      :showNum="false"
      :bottomBtnSwitch="bottomBtnSwitch"
      @closeSheet="closeSheet"
      @sureSelectSku="sureSelectSku"
    />
    <!-- 无结果 -->
    <div v-if="getCartList.isEmpty" class="none_list">
      <img src="@/assets/common/cart@2x.png" alt="" />
      <div class="font14 font_weight400 colo038 line_height_20">
        空空如也，快去加购好物吧！
      </div>
      <div class="go_home" @click="goHome">去逛逛</div>
    </div>
    <div class="bottom_margin"></div>
  </div>
</template>
<script>
import ProductList from "./components/ProductList";
import ListHeader from "./components/ListHeader";
import CantBuy from "./components/CantBuy";
import BottomBtn from "./components/BottomBtn";
const TitleBarBack = () =>
  import("@/components/TitleBarBack").then(m => m.default || m);
const SkuActionSheet = () =>
  import("../product/detail/components/SkuActionSheet").then(
    m => m.default || m
  );
// const RecomSwitch = () =>
//   import("../product/detail/components/RecomSwitch").then(m => m.default || m);
export default {
  name: "Cart",
  components: {
    TitleBarBack,
    ProductList,
    // RecomSwitch,
    ListHeader,
    CantBuy,
    BottomBtn,
    SkuActionSheet
  },
  // getCartList
  computed: {
    getCartList() {
      return this.$store.getters.getCartList;
    }
  },
  data() {
    return {
      showDeleteAll: false,
      allSelect: false,
      showSkuSheet: false,
      skuNum: 1,
      bottomBtnSwitch: "selectSku",
      specId: "",
      specSkuId: ""
    };
  },
  created() {
    this.getData();
  },
  methods: {
    // 获取数据
    getData() {
      const params = {
        slug: this.slug
      };
      this.$store
        .dispatch("cart/getCartList", {
          params
        })
        .then(() => {
          // this.isCheckedleAll();
        })
        .catch(() => {});
    },
    // 批量修改选中状态 batchSelect
    batchSelectData(params) {
      this.$store
        .dispatch("cart/batchSelect", { params })
        .then(() => {
          this.getData();
        })
        .catch(() => {});
    },
    // 批量删除 batchDelete
    batchDelete(params) {
      this.$store
        .dispatch("cart/batchDelete", { params })
        .then(() => {
          this.getData();
          this.$toast("删除成功");
          this.showDeleteAll = false;
        })
        .catch(() => {});
    },
    // 修改数量 updateCart
    updateCart(params) {
      this.$store
        .dispatch("cart/updateCart", { params })
        .then(() => {
          this.getData();
        })
        .catch(() => {});
    },
    // 单个选中状态
    batchSingleSelect(id, isSelected) {
      const params = {
        idList: [id],
        isSelected: isSelected ? 0 : 1,
        slug: this.slug
      };
      this.batchSelectData(params);
    },
    clickDelete() {
      this.showDeleteAll = !this.showDeleteAll;
      // console.log("点击管理");
    },
    // 切换底部推荐
    // switchCase(index) {
    //   console.log("切换index" + index);
    // },
    // 单个类型是否全部被选中
    isSingleAll(type, item) {
      if (item && item.length) {
        const singleFilters = item.filter(i => i.isSelected);
        if (item.length == singleFilters.length) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    // 单个类型全选按钮
    isCheckedSingleAll(type, arr) {
      // 是否全选
      const isSelected = this.isSingleAll(type, arr);
      var datas = {
        idList: [],
        isSelected: isSelected ? 0 : 1,
        slug: this.slug
      };
      for (let index = 0; index < arr.length; index++) {
        const item = arr[index];
        datas.idList.push(item.id);
      }
      if (datas.idList.length > 0) {
        this.batchSelectData(datas);
      }
    },
    // 全选是否被选中
    isAll() {
      const { tCartArrayDTO } = this.getCartList;
      const list = tCartArrayDTO.slice(0, tCartArrayDTO.length - 1); //所有正常商品
      const trueList = list.filter(i => i.list.length); //存在类型的所有商品
      if (trueList && trueList.length) {
        let allFilters = [];
        trueList.map(items => {
          allFilters.push(...items.list.filter(i => i.isSelected === 1));
        });
        let listLength = 0;
        trueList.map(items => {
          listLength += items.list.length;
        });
        if (listLength === allFilters.length) {
          return true;
        } else {
          return false;
        }
      }
      return false;
    },
    // 筛选选中的商品
    checkedAllIds() {
      const { tCartArrayDTO } = this.getCartList;
      const list = tCartArrayDTO.slice(0, tCartArrayDTO.length - 1); //所有正常商品
      const trueList = list.filter(i => i.list.length); //存在类型的所有商品
      const lists = [];
      if (trueList && trueList.length) {
        trueList.map(items => {
          lists.push(...items.list.filter(i => i.isSelected));
        });
      }
      const idList = [];
      for (let index = 0; index < lists.length; index++) {
        const item = lists[index];
        idList.push(item.id);
      }
      return idList;
    },
    // 所有商品一维数组
    selectAllIds() {
      const { tCartArrayDTO } = this.getCartList;
      const list = tCartArrayDTO.slice(0, tCartArrayDTO.length - 1); //所有正常商品
      const trueList = list.filter(i => i.list.length); //存在类型的所有商品
      const lists = [];
      if (trueList && trueList.length) {
        trueList.map(items => {
          lists.push(...items.list);
        });
      }
      const idList = [];
      for (let index = 0; index < lists.length; index++) {
        const item = lists[index];
        idList.push(item.id);
      }
      return idList;
    },
    // 底部全选
    isCheckedleAll() {
      const isAllSelected = this.isAll();
      var datas = {
        idList: this.selectAllIds(),
        isSelected: isAllSelected ? 0 : 1,
        slug: this.slug
      };
      if (datas.idList.length > 0) {
        this.batchSelectData(datas);
        return;
      }
    },
    // 管理删除按钮
    deleteCart() {
      if (this.checkedAllIds().length) {
        this.$dialog
          .confirm({
            message: "确定删除选中商品吗？",
            confirmButtonText: "确定",
            confirmButtonColor: "#DD9132"
          })
          .then(() => {
            var datas = {
              idList: this.checkedAllIds(),
              slug: this.slug
            };
            this.batchDelete(datas);
          })
          .catch(() => {
            // console.log(123)
          });
      } else {
        this.$toast("请选择删除的商品");
      }
    },
    // 删除单个商品
    deleteProduct(id) {
      var datas = {
        idList: [id],
        slug: this.slug
      };
      this.batchDelete(datas);
    },
    // 清空失效宝贝
    clearAllCant() {
      const { tCartArrayDTO } = this.getCartList;
      const noneList = tCartArrayDTO.slice(tCartArrayDTO.length - 1)[0].list;
      // console.log(noneList);
      const idList = [];
      if (noneList && noneList.length) {
        noneList.map(items => {
          idList.push(items.id);
        });
      }
      var datas = {
        idList,
        slug: this.slug
      };
      this.batchDelete(datas);
    },
    // 修改数量
    changeNum(value, id) {
      const params = {
        id,
        amount: value,
        slug: this.slug
      };
      this.updateCart(params);
    },
    // 结算
    goPurCheckOut() {
      // 下单
      if (this.checkedAllIds().length) {
        const params = {
          idList: this.checkedAllIds(),
          buyNow: 0,
          slug: this.slug
        };
        // preCheckout
        this.$store
          .dispatch("cart/preCheckout", { params })
          .then(() => {
            this.$router.push({
              path: "/order/purchase",
              query: {
                buyNow: 0,
                idList: JSON.stringify(this.checkedAllIds())
              }
            });
            localStorage.removeItem("pur-note");
            localStorage.removeItem("pur-address");
            localStorage.removeItem("mall-wap-pur-choosedate");
          })
          .catch(() => {});
      } else {
        this.$toast("请选择结算的商品");
      }
    },
    // 选择商品规格 mallretailspuChoice
    getChoiseData(spuId) {
      // console.log(6666);
      this.$store
        .dispatch("product/mallretailspu", {
          params: { spuId, slug: this.slug }
        })
        .then(() => {
          // console.log("弹出");
          this.showSkuSheet = true;
          // console.log(this.showSkuSheet, "this.showSkuSheet");
        })
        .catch(() => {});
    },
    chooseSpec(spuId, skuId, id) {
      // console.log(spuId, skuId, id);
      this.specId = id;
      this.specSkuId = skuId;
      // console.log(spuId, skuId, id, "选择弹窗");
      // this.showSkuSheet = true;
      this.getChoiseData(spuId);
    },
    // 关闭sku选择器
    closeSheet() {
      this.showSkuSheet = false;
    },
    // sku选择
    sureSelectSku(value) {
      // console.log(value, "value");
      // console.log(this.specId, "this.specId");
      const params = {
        id: this.specId,
        skuId: value.selectedSkuComb ? value.selectedSkuComb.id : "",
        slug: this.slug
      };
      this.updateCart(params);
      this.showSkuSheet = false;
    },
    // 跳转商详
    goProductDetail(spuId) {
      this.$emit("goProductDetail", spuId);
      this.$router.push({
        path: "/product/detail",
        query: {
          id: spuId
        }
      });
    },
    goHome() {
      this.$router.push("/home");
    }
  }
};
</script>
<style lang="less" scoped>
.bottom_margin {
  height: 130px;
}
.cart_new_con {
  // background: #fff;
  // margin-bottom: 120px;
  .list_list {
    margin-top: 12px;
    border-radius: 8px;
  }
  .title_right {
    width: 36px;
    line-height: 40px;
  }
  ::v-deep .switch_list {
    background: #fff !important;
  }
  ::v-deep .con {
    background: #fff !important;
  }
  .none_list {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -70%);
    img {
      width: 100px;
    }
    .go_home {
      margin-top: 52px;
      box-shadow: 0px 2px 4px 0px rgba(146, 88, 28, 0.2);
      border-radius: 20px;
      border: 1px solid #bf9264;
      font-weight: 600;
      color: #bf9264;
      line-height: 20px;
      font-size: 14px;
      padding: 10px 30px;
      display: inline-block;
    }
  }
}
</style>
